import { Component, OnInit, ViewChild } from '@angular/core';
import { helpVideoInterface, menuListInterface, VideoNode } from 'src/app/models/videoModel';
import helpVideoData from '../../../assets/helpVideo.json';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HtmlVideoTagComponent } from 'src/app/components/html-video-tag/html-video-tag.component';
import testHelpVideoData from '../../../assets/test-video.json';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  content: any;
  category: string;
}
import { MatAccordion } from '@angular/material/expansion';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-help-video-web',
  templateUrl: './help-video-web.component.html',
  styleUrls: ['./help-video-web.component.css']
})
export class HelpVideoWebComponent implements OnInit {

  @ViewChild(MatAccordion)
  accordion!: MatAccordion;
  categoryName: string = '';
  helpVideos: helpVideoInterface[] = helpVideoData.video
  categoryHelpVideos: any
  menuListItems: menuListInterface[] = helpVideoData.menuList
  treeViewData: VideoNode[] = helpVideoData.treeView
  testHelpVideos: any = []
  filterVideos: any = []
  searchText: any
  searchDeskText: any;
  selectedItem: any;
  selectedVideo: any = [];
  videoData: any
  show: boolean = false;
  selectedVideoItem: any;
  constructor(private dialog: MatDialog, private spinner: NgxSpinnerService) {
    var userName = localStorage.getItem('userName');
    if(userName == undefined){
      this.show=true;
    }
    else {
      this.show = false;
    }
    this.dataSource.data = this.treeViewData;
 
  }

  ngOnInit(): void {
    this.selectedItem = 0;
    this.testHelpVideos = testHelpVideoData
    setTimeout(() => {

    document.getElementById('inner-item0')?.click()
    document.getElementById('link0')?.click()
    },200);

    // window.addEventListener('message', this.receiveMessage.bind(this));
  }

  // receiveMessage(event: MessageEvent) :void {
  //   if (event.origin === 'http://127.0.0.1:5500/helpVideo.html' && event.data && typeof event.data === 'object') {
  //     const data = event.data;

  //     // Check for the message type or action you expect
  //     if (data.action === 'hideElement' && typeof data.targetId === 'string') {
  //       const targetId = data.targetId;
  //       // Hide the specified element in the Angular component
  //       const elementToHide = document.getElementById(targetId);
  //       if (elementToHide) {
  //         elementToHide.style.display = 'none';
  //       }
  //     }
  
  //   }
  
  // }

  ngAfterViewInit() {
    (document.getElementById('Login+default') as HTMLElement).click()
    this.accordion.openAll()
  }

  searchVideo() {
    if (this.searchText != '') {
      this.filterVideos = this.helpVideos.filter((video, index) => {
        return video.name.toUpperCase().includes(this.searchText.toUpperCase()) && video
      })
    }
  }

  highlightVideo() {
    if (this.searchDeskText != '') {
      this.treeViewData.map((video, index) => {
        video.data?.map((item, index) => {
          if (item.name.toUpperCase().includes(this.searchDeskText.toUpperCase())) {
            this.filterVideos.push(item)
          }
        })
      })
    }
  }

  updateSelection(categoryId: any) {
    this.selectedItem = categoryId;
    let cat = this.menuListItems[categoryId].selection
    this.helpVideos = this.testHelpVideos[cat]
    this.categoryHelpVideos = this.testHelpVideos[cat]
  }

  clearFilter() {
    if (this.searchText == '' || this.searchDeskText == '') {
      this.filterVideos = []
    }
  }

  clearSearchField() {
    this.searchText = ''
    this.searchDeskText = ''
    if (this.searchText == '') {
      this.filterVideos = []
    }
  }

  selectedItemIndices: any[] = [];
  openVideoDialog(video: any, index: number, accordionIndex: number) {
    // this.dialog.open(HtmlVideoTagComponent,{
    //   data : video,
    //   maxWidth : '65vw'
    // })
    
    this.selectedItemIndices[accordionIndex] = index;
    this.selectedVideoItem = video;
    this.spinner.show()
    this.videoData = ''
    setTimeout(() => {

      this.videoData = video
      this.spinner.hide()

    }, 2000)
  }

  openSearchVideoDialog(video: any) {
    // this.dialog.open(HtmlVideoTagComponent,{
    //   data : video,
    //   maxWidth : '65vw'
    // })
    
    this.selectedVideoItem = video;
    this.spinner.show()
    this.videoData = ''
    setTimeout(() => {

      this.videoData = video
      this.spinner.hide()

    }, 2000)
  }

  currentOpenedAccIndex: any;
  onAccordionOpened(accordionIndex: number): void {
    if (this.currentOpenedAccIndex !== null && this.currentOpenedAccIndex !== accordionIndex) {
      this.selectedItemIndices[this.currentOpenedAccIndex] = null;
    }
    this.currentOpenedAccIndex = accordionIndex;
  }

  //tree view section
  private _transformer = (node: VideoNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      content: node.data!,
      category: node.category!
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  triggerParentEvent(node: any) {
    this.selectedVideo = node.content
    this.categoryName = node.name
  }

  triggerChildEvent(node: any) {
    this.selectedVideo = node.content
    this.categoryName = node.category
  }

}
